exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".td-id[data-v-c7e2d35a]{width:40px;max-width:40px;min-width:40px;text-align:center}.td-name[data-v-c7e2d35a],.td-sum[data-v-c7e2d35a]{width:auto}.text-value-td-div[data-v-c7e2d35a]{padding-top:8px}.super-small-td[data-v-c7e2d35a],.super-small-th[data-v-c7e2d35a]{vertical-align:middle!important;padding:2px 5px;font-size:11px;border:1px solid #ccc}.super-small-th[data-v-c7e2d35a]{font-size:10px;padding:3px 5px}.super-small-td div[data-v-c7e2d35a]{padding:0}", ""]);

// exports
